import * as ActionAuth from '../../../action/Auth';
import * as ActionGroupManifest from '../../../action/Manifest/ScanManifest/ActionGroupManifest';
import * as ActionLogin from '../../../../module/Login/Store';
import * as toggle from '../../../action/toggle/index';

import { call, put, select, takeLatest } from 'redux-saga/effects';

import { Modal } from 'antd';
import React from 'react';
import axios from 'axios';

export function* S_EditGrupList(action: any) {
  const state = yield select();
  const token = state.Auth.Token;
  const config = {
    Authorization: `bearer ${token}`,
    'Content-type': 'application/json',
  };
  const GroupId = state.ScanManifest.GroupId;
  const IdCustomerProduct =
    state.ScanManifest.ScanManifestForm.ManifestProductForm;
  const GroupName = state.ScanManifest.GroupNameForm;
  const statusTokenRefresh = state.Auth.StatusTokenRefresh;
  try {
    yield put(toggle.changeLoadingTrue());

    yield call(
      axios.put,
      process.env.REACT_APP_URL + '/GroupManifest/UpdateIvestigasi/' + GroupId,
      {
        nameManifest: GroupName,
        customerProductId: IdCustomerProduct,
      },
      { headers: config }
    );
    if (statusTokenRefresh === true) {
      yield put(ActionAuth.changeStatusTokenRefresh(false));
    }
    yield put(ActionGroupManifest.clearGroupList());
    yield put(ActionGroupManifest.clearGroupName());
    yield put(ActionGroupManifest.clearGroupId());
    yield put(ActionGroupManifest.getGroupList());
    yield put(toggle.changeLoadingFalse());

    Modal.success({
      title: (
        <p style={{ color: '#31E116' }}>
          <b>Berhasil Merubah Data Produk</b>
        </p>
      ),
      onOk() {},
    });
  } catch (error) {
    yield put(ActionLogin.errorHandling(action, error));
  }
}

export function* SM_EditGrupList() {
  yield takeLatest('EDIT_GROUP_LIST', S_EditGrupList);
}
